module.exports = __webpack_public_path__ + "static/media/air-conditioner-open.82a9ce66.png";